module.exports = __webpack_public_path__ + "static/media/cube-grid.c17684f7.less";